/**
 * @generated SignedSource<<487dc798a592ee14a5d7b746260d2f4b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type TodoFeedbackStatus = "FEEDBACK_COMPLETED" | "FEEDBACK_DISMISSED" | "FEEDBACK_NEEDED";
import { FragmentRefs } from "relay-runtime";
export type TodoEditFeedbackPopoverSendFeedbackForm_todo$data = {
  readonly allTodoFeedbacks: ReadonlyArray<{
    readonly body: string | null;
  }>;
  readonly contact: {
    readonly email: string | null;
    readonly name: string | null;
    readonly phoneNumber: string | null;
  } | null;
  readonly feedbackStatus: TodoFeedbackStatus | null;
  readonly id: string;
  readonly title: string;
  readonly " $fragmentSpreads": FragmentRefs<"TodoContact_todo">;
  readonly " $fragmentType": "TodoEditFeedbackPopoverSendFeedbackForm_todo";
};
export type TodoEditFeedbackPopoverSendFeedbackForm_todo$key = {
  readonly " $data"?: TodoEditFeedbackPopoverSendFeedbackForm_todo$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoEditFeedbackPopoverSendFeedbackForm_todo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TodoEditFeedbackPopoverSendFeedbackForm_todo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "feedbackStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TodoContact",
      "kind": "LinkedField",
      "name": "contact",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "email",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "phoneNumber",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoContact_todo"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TodoFeedback",
      "kind": "LinkedField",
      "name": "allTodoFeedbacks",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "body",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Todo",
  "abstractKey": null
};

(node as any).hash = "4f3d26fe00932b6469abde15f04bbbc9";

export default node;
